import olPolygon from 'ol/geom/Polygon.js';
import olFormatGeoJSON from 'ol/format/GeoJSON.js';

import mapbsRealestatebuilding from 'mapbs/components/realestateinformation/model/mapbsrealestatebuildingmodel';
import mapbsRelatedrealestates from 'mapbs/components/realestateinformation/model/mapbsrealatedrealestatesmodel';

export default class mapbsRealestateinformation {
    constructor() {
        /**@type {string} */
        this.egrid = '';
        /**@type {string} */
        this.sectionNumber = '';
        /**@type {number} */
        this.parcelNumber = 0;
        /**@type {string} */
        this.typeRe = '';
        /**@type {string} */
        this.typeReTxt = '';
        /**@type {number} */
        this.area = 0;

        /**@type {string} */
        this.oerebExtractUrl = '';
        /**@type {string} */
        this.oerebExtractExtendedUrl = '';
        /**@type {string} */
        this.ownershipInformationUrl = '';
        /**@type {string} */
        this.landcoverReportUrl = '';

        /**@type {string} */
        this.landregisterExtractUrl = '';
        /**@type {string} */
        this.guidelineInformationUrl = '';

        /**@type {olPolygon} */
        this.geometry = null;

        /**@type {Array<mapbsRealestatebuilding>} */
        this.buildings = [];

        /**@type {Array<mapbsRelatedrealestates>} */
        this.relatedRealEstates = [];

    }

    getRealestateInfoObject(jsonObj) {
        this.egrid = jsonObj['Egrid'];
        this.sectionNumber = jsonObj['SectionNumber'];
        this.parcelNumber = jsonObj['ParcelNumber'];
        this.typeRe = jsonObj['Type'];
        this.typeReTxt = `realestateinfo_${this.typeRe}`;
        this.area = jsonObj['Area'];

        if ('Geometry' in jsonObj) {
            const geojson = new olFormatGeoJSON();
            this.geometry = geojson.readFeature(jsonObj['Geometry']);
        }

        this.oerebExtractUrl = jsonObj['AdditionalLinks']['OerebExtract'];
        this.oerebExtractExtendedUrl = jsonObj['AdditionalLinks']['OerebExtractExtended'];
        this.ownershipInformationUrl = jsonObj['AdditionalLinks']['OwnershipInformation'];
        this.landcoverReportUrl = jsonObj['AdditionalLinks']['LandcoverReport'];
        this.landregisterExtractUrl = jsonObj['AdditionalServices']['LandregisterExtract'];
        this.guidelineInformationUrl = jsonObj['AdditionalServices']['GuidelineInformation'];
        this.buildings = this.getBuildings(jsonObj['Buildings']);
        this.realatedRealestates = this.getRelatedRealestates(jsonObj['RelatedRealEstates']);
    }

    getBuildings(jsonObj) {
        const buildings = [];
        jsonObj.forEach(element => {
            const building = new mapbsRealestatebuilding();
            building.getRealestateBuildingObject(element);
            if(['Gebäude fertiggestellt', 'Gebäude projektiert', 'Gebäude im Bau'].find(x => x === building.buildingStatus)) {
                buildings.push(building);
            }
        });
        return buildings;
    }

    getRelatedRealestates(jsonObj){
        const realatedRealestates = [];
        jsonObj.forEach(element => {
            const related = new mapbsRelatedrealestates();
            related.getRelatedRealestate(element);
            realatedRealestates.push(related);
        });

        return realatedRealestates;
    }
}

